export interface OrderInput {
  crop?: {
    crop_name: string;
  } | null;
  blend?: {
    blend_name: string;
  } | null;
}
export function sortOrderInputs<T extends OrderInput>(inputs: T[]): T[] {
  const inputsSortedByCropBlendName = [...inputs];
  inputsSortedByCropBlendName.sort((a, b) => {
    const aName = a.crop?.crop_name?.toLowerCase() ?? a.blend?.blend_name?.toLowerCase() ?? '';
    const bName = b.crop?.crop_name?.toLowerCase() ?? b.blend?.blend_name?.toLowerCase() ?? '';

    if (aName < bName) {
      return -1;
    }
    if (aName > bName) {
      return 1;
    }

    return 0;
  });

  return inputsSortedByCropBlendName;
}
